export default {
    props: {
        editor: {
            type: Object,
            required: true,
        },
        option: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            refRichTextMenu: this.$parent.$refs.refRichTextMenu.__vue__,
        };
    },
    methods: {
        // Get the extension option from the RichTextMenu
        getExtensionOption(option) {
            return this.refRichTextMenu.getExtensionOption(option);
        },
        // Get the active style from the RichTextMenu
        activeStyle(option) {
            return this.refRichTextMenu.activeStyle(option);
        },
    },
};
